import React, { Component } from 'react'
import { Modal, Button, Row, Col } from 'react-bootstrap'
import {reduxForm, Field} from 'redux-form'
import { required } from '../../util/validationFunctions'
import InputText from '../comun/form/InputText'
import InputCheckBox from '../comun/form/InputCheckBox'
import InputSelect from 'react-select'
import InputNumerical from '../comun/form/InputNumerical'
import InputTextArea from '../comun/form/InputTextArea'
import Dropzone from 'react-dropzone'
import { Unarchive } from '@material-ui/icons'
import './ImportarClientesExcel.scss'

class ImportarClientesExcel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      archivos: '',
      archivoCargado: false
    }
  }

  onDrop (archivos) {
    archivos.map((archivo, i) => {
      var reader = new FileReader();
      reader.onloadend = () => {
        archivo.content=reader.result
        this.props.actions.subirArchivosImportarClientesExcel({name: archivo.name, file: reader.result})
        this.setState({archivos: {name: archivo.name, file: reader.result}})
        this.setState({archivoCargado: true})
      }
      reader.readAsDataURL(archivo)
    })
  }

  submitImportarClientesExcel () {
    this.props.actions.submitImportarClientesExcel(this.state.archivos)
    this.setState({archivoCargado: false})
  }

  cerrarModalImportarClientesExcel () {
    this.props.actions.cerrarModalImportarClientesExcel()
    this.setState({archivos: ''})
    this.setState({archivoCargado: false})
  }

  descargarPlantillaExcelClientesExcel () {
    this.props.actions.descargarPlantillaExcelClientesExcel()
  }

  render () {
    const {
      t, handleSubmit, showModalImportarClientesExcel, archivoExcel, listImportarClientesExcel
      } = this.props

    if(!showModalImportarClientesExcel) return null

    let errorImportar = listImportarClientesExcel.filter(item => item.insertado===false)
    let totalImportados = listImportarClientesExcel.length;
    let totalErrores = errorImportar.length;
    let totalCorrectos = totalImportados - totalErrores;
    return (
      <Modal show={showModalImportarClientesExcel} onHide={() => this.cerrarModalImportarClientesExcel()} aria-labelledby="contained-modal-title-lg" backdrop="static" className="form-carga-index">
      <form>
        <Modal.Header closeButton>
          <Modal.Title>
          {t('IMPORTAR_CLIENTES_EXCEL.TITLE')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <div className="archivos-carga-index">
              <Dropzone
                accept=".xls,.xlsx"
                onDrop={this.onDrop.bind(this)}
                uploadMultiple={true}
                maxFiles={null}
                // maxSize={200000}
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()}  className="custom-file-label">
                    <input {...getInputProps()} />
                    <label><span className="explorar-input-file">{t('COPIA_SEGURIDAD.SUBIR_ARCHIVO')}</span></label>
                  </div>
                )}
              </Dropzone>
            </div>
            {
              Object.keys(archivoExcel).length > 0 ? (
                <p className="nombre-archivo-subido"><Unarchive />{archivoExcel.name}</p>
              ) : null
            }  
            {
              totalImportados > 0 && (
                <div className="resultado-importar-clientes">
                  <p>
                    <strong>{t('IMPORTAR_CLIENTES_EXCEL.RESUMEN')}</strong><br />
                    {t('IMPORTAR_CLIENTES_EXCEL.IMPORTADOS_CORRECTAMENTE', { correctos: totalCorrectos, total: totalImportados })}
                  </p>
                </div>
              )
            }          
            {
              Object.keys(errorImportar).length > 0 ? (               
                <div className="resultado-importar-clientes error-importar">                  
                  <ul>      
                    <li><strong>{t('IMPORTAR_CLIENTES_EXCEL.ERROR')}</strong></li>              
                    {
                      errorImportar.map((cliente, idx) => (
                        <li key={idx}>
                          <div>* {cliente.razonSocialCliente || cliente.cifCliente}</div>                          
                        </li>
                      ))
                    }
                  </ul>
                </div>
              ) : Object.keys(listImportarClientesExcel).length > 0 ? (
                <div className="resultado-importar-clientes">                
                  <ul>                                          
                    <li>{t('IMPORTAR_CLIENTES_EXCEL.DOCUMENTO_SUBIDO')}</li>                      
                  </ul>                                      
                </div>
              ) : null
            }
          </Row>
        </Modal.Body>
        <Modal.Footer>          
          <Button type="button" onClick={() => this.descargarPlantillaExcelClientesExcel()} className="btn btn-primary">{t('IMPORTAR_CLIENTES_EXCEL.DESCARGAR_EJEMPLO_EXCEL')}</Button>
          {
            Object.keys(listImportarClientesExcel).length === 0 ? (
              <Button type="button" onClick={() => this.submitImportarClientesExcel()} className="btn btn-primary">{t('CARGA_INDEX.ACEPTAR')}</Button>
            ) : null
          }
          <Button type="button" className="btn btn-white" onClick={() => this.cerrarModalImportarClientesExcel()}>{t('CARGA_INDEX.CANCELAR')}</Button>
        </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default (reduxForm({
  form: 'ImportarClientesExcel',
})(ImportarClientesExcel))